import { render } from "./PosteLettre.vue?vue&type=template&id=3558adfe&scoped=true&ts=true"
import script from "./PosteLettre.vue?vue&type=script&lang=ts"
export * from "./PosteLettre.vue?vue&type=script&lang=ts"

import "./PosteLettre.vue?vue&type=style&index=0&id=3558adfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3558adfe"]])

export default __exports__